module.exports = __webpack_public_path__ + "39f2de5fac72fe5a7dbc2827c368af62.MP3";